import { render, staticRenderFns } from "./reportconfig.vue?vue&type=template&id=48f27efb&scoped=true&"
import script from "./reportconfig.vue?vue&type=script&lang=js&"
export * from "./reportconfig.vue?vue&type=script&lang=js&"
import style0 from "./reportconfig.vue?vue&type=style&index=0&id=48f27efb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f27efb",
  null
  
)

export default component.exports